import { render, staticRenderFns } from "./MessageboxTable.vue?vue&type=template&id=28a31f46&"
import script from "./MessageboxTable.vue?vue&type=script&lang=js&"
export * from "./MessageboxTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports